import { render, staticRenderFns } from "./HomeFooterFixed.vue?vue&type=template&id=8d232c3a&scoped=true&"
import script from "./HomeFooterFixed.vue?vue&type=script&lang=js&"
export * from "./HomeFooterFixed.vue?vue&type=script&lang=js&"
import style0 from "./HomeFooterFixed.vue?vue&type=style&index=0&id=8d232c3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d232c3a",
  null
  
)

export default component.exports